import React from 'react';
import { BadgeProps } from '@frontend/shadcn/components/ui/badge';
import { Tooltip, TooltipTrigger, TooltipProvider } from '@frontend/shadcn/components/ui/tooltip';
import {
  TooltipHeader,
  TooltipTitle,
  TooltipBody,
  TooltipItem,
  TooltipItemKey,
  TooltipItemValue,
  TooltipContent,
} from '../../../components/tooltip';
import { DismissableBadge } from '../../../components/filters/badges/dismissable-badge';

interface DateFilterMethodBadgeProps {
  data: Array<{ value: string; label: string; description?: string }>
  onDismiss: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

type CombinedProps = BadgeProps & DateFilterMethodBadgeProps;

const DateFilterMethodBadge = React.forwardRef<HTMLDivElement, CombinedProps>(({ data, ...props }, ref) => {
  if (data.length === 0) {
    return null;
  }

  const selectedOption = data[0];

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div>
            <DismissableBadge
              ref={ref}
              key={selectedOption.value}
              variant="secondary"
              className="mr-2 mb-2"
              aria-label="Date filter method"
              role="button"
              data-dd-action-name="open-analytics-filters"
              {...props}
            >
              Date Filter Method:<span className="capitalize ml-1">{selectedOption.label}</span>
              {
                data.length > 1 && <span className="ml-1">+{data.length - 1}</span>
              }
            </DismissableBadge>
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <TooltipHeader>
            <TooltipTitle>Date Filter Method</TooltipTitle>
          </TooltipHeader>
          <TooltipBody>
            <TooltipItem>
              <TooltipItemKey>Selected Method</TooltipItemKey>
              <TooltipItemValue>
                {selectedOption.label}
                {selectedOption.description && (
                  <div className="text-xs text-muted-foreground mt-1">
                    {selectedOption.description}
                  </div>
                )}
              </TooltipItemValue>
            </TooltipItem>
            {data.length > 1 && (
              <TooltipItem>
                <TooltipItemKey>Additional Methods</TooltipItemKey>
                <TooltipItemValue>
                  {data.slice(1).map((option) => option.label).join(', ')}
                </TooltipItemValue>
              </TooltipItem>
            )}
          </TooltipBody>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
});

DateFilterMethodBadge.displayName = 'DateFilterMethodBadge';

export { DateFilterMethodBadge };
